import LawFirmSummary from './LawFirmSummary';

export default LawFirmSummary;
